// Constantes gender — genre déclaré du membre.
//
// Source de vérité côté frontend pour les VALEURS ENUM + un fallback FR.
// Aligné sur backend/config/gender.js (valeurs ENUM identiques).
// Affichage i18n : business:gender.<value> (GENDER_LABELS = fallback data-safe).
//
// Si tu ajoutes une valeur ici, propage dans :
//   1. la migration backend (ALTER TABLE MODIFY COLUMN)
//   2. le modèle Sequelize ENUM
//   3. backend/config/gender.js (VALUES)
//   4. business.json (fr/en/es) clé gender.<value>

import { formatDateI18n } from './i18nFormatters'

export const GENDER_VALUES = ['female', 'male', 'other', 'not_specified']

// Fallback FR (data-safe) : utilisé hors React ou si `t` absent.
export const GENDER_LABELS = {
  female: 'Femme',
  male: 'Homme',
  other: 'Autre',
  not_specified: 'Non précisé',
}

export const isValidGender = (value) => GENDER_VALUES.includes(value)

// Label affichable d'un genre. Avec `t` → i18n (fallback FR via defaultValue) ;
// sans `t` → map FR. Valeur inconnue → '' (le caller décide du fallback).
export const getGenderLabel = (value, t) => {
  if (!value) return ''
  if (t) return t(`business:gender.${value}`, { defaultValue: GENDER_LABELS[value] || '' })
  return GENDER_LABELS[value] || ''
}

// Affichage d'une date de naissance (string 'YYYY-MM-DD') en date longue localisée.
// `lang` optionnel (fallback fr via i18nFormatters). Retourne '' si vide/invalide
// (le caller décide du fallback).
export const formatBirthDate = (value, lang) => {
  if (!value) return ''
  return formatDateI18n(value, 'PPP', lang)
}
